module.exports = __webpack_public_path__ + "07005a7fd06016e6ceadc545e3296f7a.svg";